export const listFormateDate = [
    {title: 'اليوم', startDate: new Date().toISOString().split("T")[0]},
    {title: 'آخر اسبوع', startDate: new Date(Date.now() - 6048e5).toISOString().split("T")[0]},
    {title: 'آخر أسبوعين', startDate: new Date(Date.now() - 12096e5).toISOString().split("T")[0]},
    {title: 'اخر شهر', startDate: new Date(Date.now() - 2592000000).toISOString().split("T")[0]},
  ]
